import { useCallback, useContext } from 'react';
import {
  CTA_GUARD_ACTION,
  CtaGuard,
  CtaGuardOutcome
} from '~/constants/common/ctaGuard';
import ModalContext from '~/context/vdp/ModalContext';
import { logInfo } from '~/utilities/loggers';

function useConfirmAfterLogin(): (onContinue: () => void) => () => void {
  const { setConfirmModalOpen } = useContext(ModalContext);

  return useCallback(
    (onContinue: () => void) => () => {
      logInfo(CTA_GUARD_ACTION, {
        guard: CtaGuard.ConfirmAfterLogin,
        outcome: CtaGuardOutcome.Opened
      });

      // Note: we can't depend on state being up-to-date here, so we don't check
      // it before showing the modal. If this hook's function is called we
      // assume the caller knows what it's doing.
      setConfirmModalOpen(true, {
        onContinue: () => {
          logInfo(CTA_GUARD_ACTION, {
            guard: CtaGuard.ConfirmAfterLogin,
            outcome: CtaGuardOutcome.Continued
          });

          setConfirmModalOpen(false);
          onContinue();
        },
        onlyConfirmCancellation: true
      });
    },
    [setConfirmModalOpen]
  );
}

export default useConfirmAfterLogin;
